import { LinkingOptions } from '@react-navigation/native';

const prefixes = ['ccjaw://', 'http://localhost:3000'];

export const linking: LinkingOptions<any> = {
  prefixes,
  config: {
    screens: {
      Main: {
        screens: {
          Missions: '',
          Chat: 'chat',
          Notifications: 'notifications',
          Account: 'account',
        },
      },
      Cart: 'cart',
      CardDiscussion: 'card-discussion/:cardId?',
      OrderPipeline: 'order-pipeline',
      Chapters: 'chapters',
      ChapterDetail: 'chapter/:id?',
      MissionCards: 'mission-cards',
      UserStories: 'user-stories',
      UserStoryDetail: 'user-story/:id?',
      MissionChat: 'mission-chat',
      Quiz: 'quiz',
    },
  },
};
